/* Child Components */
import PlaceAutocompletePrediction from 'components/signup/autocomplete/PlaceAutocompletePrediction';

/* Styled Components */
import {
  AutocompleteContainerWrapper,
  AutocompleteContainer,
  AutocompleteResultsContainer,
  GoogleAttribution,
} from 'styles/signup/Autocomplete';

/* Types */
import type { PlaceAutocompletePredictionType } from 'types/GooglePlacesTypes';

type PropsType = {
  predictions: Array<PlaceAutocompletePredictionType>;
  selectedIndex: number | null | undefined;
  onOptionClicked: (placeId: string) => void;
  visible: boolean;
};

const PlaceAutocompleteList = ({
  predictions,
  selectedIndex,
  onOptionClicked,
  visible,
}: PropsType) => {
  if (!visible || predictions.length === 0) {
    return null;
  }

  return (
    <AutocompleteContainerWrapper>
      <AutocompleteContainer>
        <AutocompleteResultsContainer>
          {predictions.map((prediction, index) => (
            <PlaceAutocompletePrediction
              key={prediction.place_id}
              prediction={prediction}
              onClick={onOptionClicked}
              isSelected={index === selectedIndex}
            />
          ))}
        </AutocompleteResultsContainer>
        <GoogleAttribution />
      </AutocompleteContainer>
    </AutocompleteContainerWrapper>
  );
};

export default PlaceAutocompleteList;
